import {Component, ViewChild} from '@angular/core';
import {GritDeviceService} from "../../../services/grit/grit.device.service";
import {TabsService} from "../../../services/tabsService";
import {GritDynamicTableMode, GritDynamicTableType} from "../../../models/grit/grit.enums";
import {DeviceModel, DeviceSectorization, DeviceSectorizationType} from "../../../models/grit/grit.device-model";
import {GritModel} from "../../../models/grit/grit.model";
import {GritDynamicTableComponent} from "../../../utils/grit/grit-dynamic-table/grit-dynamic-table.component";
import {GritApiService} from "../../../services/grit/grit.api.service";
import {GritUserRoleGroup, GritUserService} from "../../../services/grit/grit.user.service";
import {cloneDeep} from "lodash";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {
  AddDeviceSectorizationComponent
} from "../../../popup/grit/add-device-sectorization/add-device-sectorization.component";
import {sectorizationGraphDataGrit} from "../../../models/sectorizationGraphData";
import {GritUtils} from "../../../utils/grit/GritUtils";
import {
  SectorizationDisplayComponent
} from "../../../popup/sectorization-display/sectorization-display/sectorization-display.component";
import {GritFeature} from "../../../models/grit/grit.feature";
import {ModalControlService} from "../../../services/modal-control.service";
import {ModalConfirmationService} from "../../../services/modal-confirmation.service";
import {GritReceiverService} from "../../../services/grit/grit.receiver.service";
import {ReceiverModel} from "../../../models/grit/grit.receiver-model";
import { GritGroupsComponent } from 'src/app/utils/grit/grit-groups/grit-groups.component';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['../../../app.component.scss','./device.component.scss'],
  standalone: false
})
export class DeviceComponent {

  selectedDevice : DeviceModel = null;
  targetReceiver : ReceiverModel = null

  @ViewChild(GritDynamicTableComponent) table: GritDynamicTableComponent
  
  readonly groupsNotNull = GritGroupsComponent.groupsNotNull;

  constructor(
   protected deviceService : GritDeviceService,
   protected receiverService : GritReceiverService,
   protected gritUserService : GritUserService,
   protected gritApiService : GritApiService,
   protected tabsService : TabsService,
   protected popupService : BsModalService,
   protected modalService: ModalControlService,
   protected modalConfirmation: ModalConfirmationService,
  ) {
  }

  tabs = [true, false]
  changeTab(index : number){
      this.tabs.forEach((_t, i) => {
        this.tabs[i] = (i == index);
      })
  }

  changeTargetReceiver(){
    this.targetReceiver = this.receiverService.getTypeReceiver(this.selectedDevice.mainType);
    this.updateField();
  }


  showDevice(model : GritModel<any>){
    if(model.id == this.selectedDevice?.id){
      this.selectedDevice = null;
    }
    else if(model.id == 0){
      this.selectedDevice = model as DeviceModel;
      this.changeTargetReceiver();
    }
    else{
      this.selectedDevice = cloneDeep(model as DeviceModel);
      this.changeTargetReceiver();
    }

    this.changeTab(0)
  }

  addDevice(){
    this.showDevice(new DeviceModel())
  }

  deleteDevice(){
    this.modalConfirmation.showMesssageConfirmationModal(
          "Delete RFI-Transmitter",
          "Do you want to delete the selected RFI-Transmitter?",
          "OK", "Cancel",
      () => {
        this.gritApiService.deviceDelete([this.selectedDevice]).then(
          (devices) => {
            devices.forEach(device => {
              let i = this.deviceService.devices.findIndex(d => d.id == device.id);
              if(i == -1) return;
              this.deviceService.devices.splice(i, 1);

              this.selectedDevice = null;
              this.table.models = this.deviceService.devices
            });
            this.modalService.showMesssageModal(
              "RFI-Transmitter Delete",
              "Successfully deleted the RFI-Transmitter.");
          },
          (error) => {
            console.error(error)
            this.modalService.showMesssageModal(
              "RFI-Transmitter Delete Error",
              "Error deleting the RFI-Transmitter.");
          }
        )
      }
    );
  }

  saveDevice(){
    this.modalConfirmation.showMesssageConfirmationModal(
      "Save RFI-Transmitter",
      "Do you want to save the RFI-Transmitter?",
      "OK", "Cancel",
      () => {
        if(this.selectedDevice.sectorizations.length > 0){
          this.selectedDevice.sectorizations = this.selectedDevice.sectorizations.filter(sector => !sector.deleted)
          this.selectedDevice.sectorizations.forEach(sector => sector.selected = false)
        }

        if(this.selectedDevice?.id == 0){
          this.gritApiService.deviceCreate([this.selectedDevice]).then(
            (device) => {
              this.deviceService.devices.push(...device);
              this.selectedDevice = null;
              this.table.models = this.deviceService.devices
            },
            (error) => {console.error(error)}
          )
        }
        else{
          this.gritApiService.deviceUpdate([this.selectedDevice]).then(
            (devices) => {
              devices.forEach(device => {
                let i = this.deviceService.devices.findIndex(d => d.id == device.id);
                if(i == -1) return;
                this.selectedDevice = null;
                this.deviceService.devices[i] = device;
              });

              this.table.models = this.deviceService.devices
            },
            (error) => {console.error(error)}
          )
        }
      }
    );
  }

  addSectorizationTrigger():void {
    const bsModalRef : BsModalRef = this.popupService.show(AddDeviceSectorizationComponent);
    return bsModalRef.content.onClose.subscribe((result: DeviceSectorization) => {
      if(result){
        this.selectedDevice.sectorizations.push(result)
      }
    })
  }

  deleteSectorizations():void {
    this.selectedDevice.sectorizations.forEach(sector => {
      if(!sector.selected) return;
      sector.deleted = !sector.deleted;
      sector.selected = false;
    })
  }

  displaySectorizations(){
    let device = this.selectedDevice;
    let sectData : sectorizationGraphDataGrit = new sectorizationGraphDataGrit();

    sectData.name = device.name;
    sectData.sectorizations = device.sectorizations.filter(sect => !sect.deleted).flatMap(sect => {
      let doc = GritUtils.fsplDistance(
        device.frequencyHz, sect.power.dBW, sect.gain + device.verticalGain, device.polarisationLoss,
        this.targetReceiver.threshold.dBW, this.targetReceiver.gain);

      return sect.toSectorization(doc, 0, 60000, /*device.direction*/ 0)
    });

    sectData.minAltitude = 0;
    sectData.maxAltitude = 60000;
    sectData.indexRange = 0;

    let doc = GritUtils.fsplDistance(
      device.frequencyHz, device.power.dBW, device.verticalGain, device.polarisationLoss,
      this.targetReceiver.threshold.dBW, this.targetReceiver.gain);

    sectData.defaultDOC = doc > 500 ? 500 : doc;

    this.gritApiService.sectorizationDisplay(sectData).then(
      (data) => {
        const bsModalRef : BsModalRef = this.popupService.show(SectorizationDisplayComponent);
        bsModalRef.content.sectorizationData = data;
      },
      (error) => {
        this.modalService.showMesssageModal("Error Displaying Sectorization",
          "Check device values.");
      }
    )
  }

  updateField(): void {
    const device = this.selectedDevice;
    device.range = this.targetReceiver == null ? 0 : GritUtils.fsplDistance(
      device.frequencyHz, device.power.dBW, device.verticalGain, device.polarisationLoss,
      this.targetReceiver.threshold.dBW, this.targetReceiver.gain);
  }

  protected readonly GritDynamicTableType = GritDynamicTableType;
  protected readonly GritDynamicTableMode = GritDynamicTableMode;
  protected readonly DeviceModel = DeviceModel;
  protected readonly GritUserRoleGroup = GritUserRoleGroup;
}
